/* eslint-disable react/jsx-pascal-case */
/* eslint-disable react/no-unstable-nested-components */
  import React, { useContext, useMemo, useState, useRef, useCallback } from 'react';
  import { MaterialReactTable, useMaterialReactTable, type MRT_ColumnDef, type MRT_ColumnFiltersState, type MRT_PaginationState, type MRT_SortingState, type MRT_RowSelectionState, MRT_ShowHideColumnsButton, MRT_ToggleFullScreenButton, MRT_GlobalFilterTextField, MRT_ToggleFiltersButton, MRT_ToggleDensePaddingButton, MRT_ToggleGlobalFilterButton, MRT_Cell, MRT_TableOptions } from 'material-react-table';
  import { Box, IconButton, Button, MenuItem, TextField } from '@mui/material';
  import RefreshIcon from '@mui/icons-material/Refresh';
  import { QueryClient, QueryClientProvider, useQuery, } from '@tanstack/react-query';
  import { postMainAppApiData, getTaxReportsApiData, serializeTaxReportBody } from 'services/api';
  import { TFunction, useTranslation } from 'react-i18next';
  import { StoreContext } from 'models/import';
  import Pill, { PillModifier } from 'components/pill';
  import { RowSelection } from '@tanstack/react-table';
  import ArrowRightIcon from 'assets/icons/arrowRight.svg';
  import Btn, { BtnModifier } from 'components/btn';
  import { FullMatchElement, MatchElement, ValidationDetail, ValidationTableDef, ValidationTableFlow, ValidationTableMatchResult, Dictionary, CoinValue, ExchangeValue, ValidationSelectOption, ValidationMaterialTableProps, GeneralTransactionType, GeneralTransactionTypeModel, generalTransactionTypes, ValidationEditItem } from 'models/validation';
  import StatusIcon, { StatusIconModifier } from 'components/statusIcon';
  import { StatusEnum } from 'models/general';
  import Tooltip, { TooltipAlignEnum, TooltipCursorEnum, TooltipModifier } from 'components/tooltip';
  import { TableDataRes } from '../base/tableBaseApi';
  import ValidationSectionSelectorComponent from 'pages/validation/components/validationSectionSelector';
  import { isTrade, getAccountBalance, getAccountBalanceAfter, getAccountBalanceByExchange, getAccountBalanceAfterByExchange, getTransactionType, getDateForValidation, getDateStringFromApi,getDateString, getExchanges, getBuy, getSell, getRowSelectionIds, getGeneralType, filterAllowedEditTransactionTypes, handleEditApiCall, getRowById, getSubRowItems, getCleanedSubRow, getStringValueForTrade, getFee, canExpand, getNotices, getSubRowPossibleMatches, getPossibleMatches, getRowId, cleanUpTableId, hasWarnings, hasDuplicates } from 'services/transactions';
  import ValidationStatusCell from 'pages/validation/components/validationStatusCell';
  import TransactionMenu, {TransactionMenuProps, TransactionMenuItems, ValidationMenuItemId} from 'pages/validation/components/transactionMenu';
  import { ThemeName } from 'models/theme';
  import ValidationEditDeleteComponent, { ValidationEditDeleteComponentProps } from 'pages/validation/components/validationEditDelete';
  import BuySellComponent from 'pages/validation/components/buySell';
 import { getMenuItems } from 'pages/validation/components/menuItems';
 import { getStripedRowsForExpansion } from 'services/util';
import { useGetValidationRequest } from 'pages/validation/network/validationRequest';
import { getDefaultMRTOptions } from '../materialTable';

  export default function ValidationNoticeTable(props: ValidationMaterialTableProps) {
    const { t } = useTranslation();
    const { userSettings, themeName } = useContext(StoreContext);
    const tableRef = useRef();

    const [sorting, setSorting] = useState<MRT_SortingState>([]);
    const [pagination, setPagination] = useState<MRT_PaginationState>({ pageIndex: 0, pageSize: 10 });
    
    const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
      [{id: "status", value: 5}],
    );
    const [filters, setFilters] = useState('{"currencies":0,"match_same_exchange":true,"amount_accuracy":90,"time_accuracy":2}');
    
    const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
    const [deleteEditEnabled, setDeleteEnabled] = useState(true);

    const isDeletebuttonDisabled = isFetching || Object.keys(rowSelection).length < 1;
    const getSelectedRowItems = useCallback(() => {
      const selectedRowIds = getRowSelectionIds(rowSelection);
      const selectedRows = (data?.data || []).filter((row: ValidationTableDef) => selectedRowIds.includes(row.transaction.id));
      return selectedRows;
    }, [rowSelection, JSON.stringify(data?.data || [])]);

    const setRowSelectionAndUpdateProps = (rowSelection: MRT_RowSelectionState) => {
      setRowSelection(rowSelection);
      props.setRowSelection(rowSelection);
    };
    
    const [fixWarningsEnabled, setFixWarningsEnabled] = useState(false);//button enabled or not
    const [warningsCurrentlyHidden, setWarningsCurrentlyHidden] = useState(false);//after calling the api we hide warnings until we change page
    const [duplicatesCurrentlyHidden, setDuplicatesCurrentlyHidden] = useState(false);//after calling the api we hide warnings until we change page
  
    const toggleDeleteEditEnabled = () => {
      if (tableRef && tableRef.current) {
        tableRef.current.resetRowSelection();
        setRowSelectionAndUpdateProps({});
      }
      return;

    };

    const handleWarningButtonPress = () => {
  if (tableRef && tableRef.current) {
    tableRef.current.resetRowSelection();
  }

  setWarningsCurrentlyHidden(true);
  postMainAppApiData<any, any>('validate_transactions.php?repair').then((res: any) => {
    return;
  }).catch((e) => {
    refetch();
  });
};

  const {
    data, isError, isFetching, isLoading, refetch,
  } = useGetValidationRequest(
      "validationNoticeTable",
      "/reports/tax/validation/validate",
      props.setIsFetching,
      columnFilters, 
      props.globalSearch, 
      pagination.pageIndex, 
      pagination.pageSize, 
      sorting, 
      filters,
      (response: TableDataRes<ValidationTableDef, ValidationDetail> | null) => {
        setWarningsCurrentlyHidden(false);//reset hidden warnings on navigation
        setDuplicatesCurrentlyHidden(false);
        props.onLoadCb(response);
        setFixWarningsEnabled(hasWarnings(response));//enable or disable warning button based on response
    }
  )
  
  const tableData = (data?.data || []);
  const [isSaving, setIsSaving] = useState(false);

    const updateRows = (id: string[], row: ValidationEditItem, fromToolbar: boolean) => {
      const mapped = tableData.map((item) => {
        if (!id.includes(item.transaction.id || -1)) {
           return item;
        }

        const itemMapped = { ...item };

        if (row.transaction_type || row.transaction_type === '0') {
          itemMapped.transaction.transaction_type = row.transaction_type;
        }
        if (row.comment) {
          itemMapped.transaction.comment = row.comment;
        }

        return itemMapped;
      });
      //set the local data, we show the updated data immediately
      setTableData([...mapped]);

      if (fromToolbar) {
        toggleDeleteEditEnabled();
      }

      setIsSaving(true);

      handleEditApiCall(id, row, () => {
        setIsSaving(false);
        refetch();
      },
      () => {
        setIsSaving(false);
        refetch();
      });
  };
  
    // Matches
  
    const deleteMatch = (pairId: number | null, transationId: number, userId: number) => {
      const queryString: string = serializeTaxReportBody({
        method: 'POST',
        path: '/reports/tax/validation/update-missing-pair',
        body: `{"user_id": ${userId}, "transaction_id": ${transationId}, "pair_id": ${pairId}}`,
        header: 'Accept: application/json',
      });
  
      getTaxReportsApiData<any>(`/ajax/query.php?${queryString}`).then((res: any) => {
        refetch();
      }).catch((e) => {
        refetch();
      });
    };
  
    const updateMatch = (pairId: number, transationId: number, userId: number) => {
      const queryString: string = serializeTaxReportBody({
        method: 'POST',
        path: '/reports/tax/validation/update-missing-pair',
        body: `{"user_id": ${userId}, "transaction_id": ${transationId}, "pair_id": ${pairId}}`,
        header: 'Accept: application/json',
      });
  
      getTaxReportsApiData<any>(`/ajax/query.php?${queryString}`).then((res: any) => {
        refetch();
      }).catch((e) => {
        refetch();
      });
    };

    const onDetailNavigate = (id: number | null): void => {
      if (!id) { return; }
      
      //We need to use jquery to fake a form submit with post
      $('<form method="POST" target="_blank" action="/enter_coins.php"><input type="hidden" name="edit_tx" value="'+id+'" /></form>')
      .appendTo('body').submit().remove();
      }

      const handleDelete = (item: number | null) => {
        if (!item) return;
        const encodedData = new URLSearchParams(`action=remove&data[row_${item}][DT_RowId]=row_${item}`);
    
        
        if (tableRef && tableRef.current) {
          tableRef.current.resetRowSelection();
          setRowSelectionAndUpdateProps({});
        }

        postMainAppApiData<any, any>('ajax/tradelist_extended.php', encodedData).then((res: any) => {
          refetch();
        }).catch((e) => {
          refetch();
        });
      };

    const columns = useMemo<MRT_ColumnDef<ValidationTableDef>[]>(
      () => [
        {
          id: 'transaction_type',
          accessorKey: 'transaction.transaction_type',
          enableColumnFilter: false,
          editVariant: 'select',
          enableEditing: false,
          header: t('Type', { ns: 'validation' }),
          accessorFn: (row) => row.transaction.transaction_type,
          Cell: (info) => {
            const stringValue = getTransactionType(info.row.original.transaction.transaction_type, info.row.original, props.transactionTypeSelectOption);
            return (<span><b>{stringValue}</b></span>);
          },
        },
        {
          id: 'sell',
          accessorKey: 'transaction.sell',
          enableEditing: false,
          header: t('Transaction', { ns: 'validation' }),
          minSize: 300,
          accessorFn: (row) => getSell(
            row.transaction.sell,
            row.transaction.sell_coin,
            row.transaction.sell_value_in_fiat,
            row.transaction.exchange,
            row,
          ),
          Cell: (info) => {
            const sell = getSell(
              info.row.original.transaction.sell,
              info.row.original.transaction.sell_coin,
              info.row.original.transaction.sell_value_in_fiat,
              info.row.original.transaction.exchange,
              info.row.original,
            );

            const buy = getBuy(
              info.row.original.transaction.buy,
              info.row.original.transaction.buy_coin,
              info.row.original.transaction.buy_value_in_fiat,
              info.row.original.transaction.exchange,
              info.row.original,
            );

            const fee = getFee(info.row.original.transaction.fee, info.row.original.transaction.fee_coin, info.row.original);
    
            return (
              <Tooltip
                cursor={TooltipCursorEnum.HELP}
                align={TooltipAlignEnum.LEFT}
                tooltipChildren={(
                  <BuySellComponent
                  sell={sell}
                  buy={buy}
                  fee={fee}
                  />
                )}
                modifiers={[]}
                key={info.column.id}
              >
              <div
                className="ct_tableBase-text-wrap-one-line"
                style={{ maxWidth: '100%' }}
              >
                <BuySellComponent
                sell={sell}
                buy={buy}
                fee={fee}
                />
              </div>
            </Tooltip>
            );
          },
        },
        {
          id: 'exchange',
          accessorKey: 'transaction.exchange',
          header: t('Account', { ns: 'validation' }),
          enableEditing: false,
          accessorFn: (row) => row.transaction.exchange,
          Cell: (info) => {
            const exchangeValue: ExchangeValue = getExchanges(
              info.row.original.transaction.exchange, 
              info.row.original
            );
    
            return (
            <div
              className="ct_tableBase-text-wrap-one-line"
              style={{ maxWidth: '155px' }}
            >
              {exchangeValue.exchange1 || ''}
              {exchangeValue.exchange1
                && exchangeValue.exchange2 && ' -> '}
              {exchangeValue.exchange2 || ''}
            </div>
          );
          },
        },
        {
          id: 'comment',
          accessorKey: 'transaction.comment',
          header: t('Comment', { ns: 'validation' }),
          accessorFn: (row) => row.transaction.comment,
          enableEditing: true,
          Cell: (info) => {
            const value = getStringValueForTrade(
              info.row.original.transaction.comment,
              info.row.original
            );
    
            return (
              <Tooltip
                cursor={TooltipCursorEnum.HELP}
                align={TooltipAlignEnum.LEFT}
                title={value || ''}
                modifiers={[]}
                key={info.column.id}
              >
              <div
                className="ct_tableBase-text-wrap-one-line"
                style={{ maxWidth: '100px' }}
              >
                {value || ''}
              </div>
            </Tooltip>
          );
          },
        },
        {
          id: 'transaction_time',
          accessorKey: 'transaction.transaction_time',
          enableColumnFilter: false,
          enableEditing: false,
          header: t('Date', { ns: 'validation' }),
          accessorFn: (row) => getDateStringFromApi(row.transaction.transaction_time, userSettings?.dateFormat, row),
          Cell: (info) => {
            const value: string = getDateForValidation(info.cell.row.original.transaction.transaction_time, userSettings?.dateFormat, info.cell.row);
            return (
            <div
              className="ct_tableBase-text-wrap-one-line"
              style={{ maxWidth: '110px' }}
            >
              {value}
            </div>
          );
          },
        },
        {
          id: 'status',
          size: 7,
          minSize: 7,
          maxSize: 7,
          header:'',
          enableEditing: false,
          enableColumnFilter: false,
          accessorFn: (row) => getPossibleMatches(row.possible_matches, row.transaction.id),
          Cell: (info) => <ValidationStatusCell 
          cell={info.cell}
          handleDuplicatesButtonPress={() => {}}
          duplicatesCurrentlyHidden={duplicatesCurrentlyHidden}
          warningsCurrentlyHidden={true}
          noticesCurrentlyHidden={false}
          isTrade={isTrade}
          deleteMatch={deleteMatch}
          updateMatch={updateMatch}
          getSubRowPossibleMatches={getSubRowPossibleMatches}
          isMatchIconOnly={true}
          showDetailButton={false}
          handleDetailClick={() => {
           onDetailNavigate(info.cell.row.original.transaction.id);
          }}
        />,
        },
      ],
      [warningsCurrentlyHidden, duplicatesCurrentlyHidden, deleteEditEnabled], // deps for reload
    );

        const defaultMRTOptions = getDefaultMRTOptions<ValidationTableDef>();

       const table = useMaterialReactTable({
      ...defaultMRTOptions,
      columns,
      data: tableData,
      initialState: {
        ...defaultMRTOptions.initialState,
        columnVisibility: {
            'mrt-row-select': deleteEditEnabled,
            'mrt-row-actions': deleteEditEnabled,
            before_balance: false,
            after_balance: false,
            before_balance_by_exchange: false,
            after_balance_by_exchange: false,
          },
      },
      muiTableBodyRowProps: (props) => ({
        ...defaultMRTOptions.muiTableBodyRowProps(props),
        onClick: (event: Event) => {
            if (isFetching) return;
            if (!canExpand(props.row.original)) return;
            event.stopPropagation();
            props.row.toggleExpanded();
        },
         sx: { 
            cursor: (!isFetching && canExpand(props.row.original)) ? 'pointer' : 'default',
            '& td': {
              backgroundColor: getStripedRowsForExpansion(props.row),
            },
         },
      }),
      muiToolbarAlertBannerProps: isError
        ? {
          color: 'error',
          children: t('Error loading data'),
        }
        : undefined,
      onColumnFiltersChange: setColumnFilters,
      onPaginationChange: (e) => {
          setRowSelectionAndUpdateProps({});
          setPagination(e);
        },
      onSortingChange: setSorting,
      onRowSelectionChange: (updater) => {
        setRowSelectionAndUpdateProps((prev) =>
          updater instanceof Function ? updater(prev) : updater,
        );
      },
      rowCount: data?.meta?.total_item_count ?? 0,
      defaultColumn: {
         ...defaultMRTOptions.defaultColumn,
        minSize:10,
        size: 20,
      },
      state: {
        ...defaultMRTOptions.state,
          columnFilters: columnFilters,
          globalFilter: props.globalSearch,
          isLoading,
          pagination,
          showAlertBanner: isError,
          showSkeletons: isFetching || isSaving || isLoading,
          sorting,
          rowSelection: rowSelection,
      },
      muiExpandButtonProps: ({
        row,
      }) => ({
        sx: {
          display: (canExpand(row.original)) ? 'flex' : 'none',
        },
      }),
      muiFilterTextFieldProps: {
        sx: { m: '0.5rem 0', width: '100%' },
      },
      getSubRows: (row) => getSubRowItems(row) ,
      getRowId: (row, index, parent) => {
        if (parent) {
          return getRowId(row, index, parent.original, parent.index) 
        } else {
          return getRowId(row, index) 
        }
      },
      renderTopToolbarCustomActions: () => (
          <div style={{ display: 'flex', gap: '0.5rem' }}>
              <ValidationEditDeleteComponent 
                isDeletebuttonDisabled={isDeletebuttonDisabled}
                isEditEnabled={false}
                isFetching={isFetching}
                statusSelectOption={props.statusSelectOption}
                transactionTypeSelectOption={props.transactionTypeSelectOption}
                rowSelection={rowSelection}
                setRowSelection={setRowSelectionAndUpdateProps}
                rowItems={getSelectedRowItems()}
                updateRows={updateRows}
              />
               {/* { fixWarningsEnabled && (
               <Button
                 color="error"
                 disabled={isFetching || !fixWarningsEnabled}
                 onClick={handleWarningButtonPress}
                 variant="contained"
               >
                 {t('Clear Warnings', { ns: 'validation' })}
               </Button>
               )} */}
            </div>
          ),
    });

    return (
      <>
      <MaterialReactTable table={table} />
      </>
    );

  }